const plants = [
  {
    id: '1',
    name: 'Aloe Vera',
    price: 12,
    category: 'Succulents',
    thumbnail: '/plants/aloe.jpg',  // <-- update here
  },
  {
    id: '2',
    name: 'Fiddle Leaf Fig',
    price: 25,
    category: 'Indoor',
    thumbnail: '/plants/fiddle.jpg',
  },
  {
    id: '3',
    name: 'Lily',
    price: 20,
    category: 'Indoor',
    thumbnail: '/plants/lily.jpg',
  },
  {
    id: '4',
    name: 'Snake Plant',
    price: 18,
    category: 'Indoor',
    thumbnail: '/plants/snake.jpg',
  },
  {
    id: '5',
    name: 'Spider Plant',
    price: 15,
    category: 'Indoor',
    thumbnail: '/plants/spider.jpg',
  },
  {
    id: '6',
    name: 'ZZ Plant',
    price: 30,
    category: 'Tropical',
    thumbnail: '/plants/zz.jpg',
  },
];

export default plants;

